import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import {
    NgbAlertModule,
    NgbDatepickerModule,
    NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { InvoiceService } from "./../../../_services/invoice.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { Config } from "src/app/_store/config";

@Component({
    selector: "app-upload-preview-logistics-digital-invoice",
    templateUrl: "./upload-preview-logistics-digital-invoice.component.html",
    styleUrls: ["./upload-preview-logistics-digital-invoice.component.scss"],
})
export class UploadPreviewLogisticsDigitalInvoiceComponent
    implements OnInit, DirtyCheckComponent
{
    Config = Config;
    docs = [
        {
            docType: "PO2S",
            description: "PO2S",
        },
        {
            docType: "PO2X",
            description: "PO2X",
        },
        {
            docType: "PO2O",
            description: "PO2O",
        },
    ];

    @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
    invoiceDetails: any;
    invoiceType: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    invoiceSaved: boolean = false;
    uploadInvoice: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    displayName: any;
    hasError = false;
    safeUrl: SafeResourceUrl = "";
    pdfSrc: any;
    fileLink: any;
    fileSizeError = false;
    fileTypeError = false;
    typeError = false;
    sizeError = false;
    supportingDocuments: any[] = [];
    agreed = [{ status: false }];
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    responseData: any;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    barcodeNo: any;
    poNo: any;
    eInvoice = false;
    reqData: any;
    formData: any;
    DocDt: NgbDateStruct;
    model: NgbDateStruct;
    irnExist: boolean = false;
    dsLoaderMsg = "";
    formSubmitted = false;
    previousUrl: any;
    companies: any;
    organisations: any;
    configResCompanies: any;
    configResOrg: any;
    totalSizeError = false;
    files: File[];
    supportingDocsAdded = false;
    invalidDate = false;
    canSubmitForm = false;
    allDeleted = false;
    dateError = false;
    serverError = false;
    error: any;

    digitalLogisticsInvoice = new FormGroup({
        SellerGstin: new FormControl("", [
            Validators.required,
            Validators.minLength(15),
            Validators.maxLength(15),
        ]),
        file_link: new FormControl(""),
        BuyerGstin: new FormControl(""),
        DocNo: new FormControl("", [Validators.required]),
        DocTyp: new FormControl(""),
        DocDt: new FormControl("", [Validators.required]),
        TotInvVal: new FormControl(null, [Validators.required]),
        ItemCnt: new FormControl(""),
        Irn: new FormControl("", [
            Validators.minLength(64),
            Validators.maxLength(64),
        ]),
        IrnDt: new FormControl(""),
        MainHsnCode: new FormControl(""),
        file: new FormControl(""),
        supportingFiles: new FormControl([]),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(false),
        username: new FormControl(""),
        userID: new FormControl(""),
        emailAddress: new FormControl(""),
        poNo: new FormControl("", [
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(10),
        ]),
        companyCode: new FormControl(null, [Validators.required]),
        purchaseOrg: new FormControl(null, [Validators.required]),
        docType: new FormControl(null, [Validators.required]),
    });

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService,
        private sanitizer: DomSanitizer,
        private authService: AuthService,
        private dateUtils: DateUtilsService
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };

        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.previousUrl = val.url;
            }
        });
    }

    setAsDirty() {
        this.digitalLogisticsInvoice.controls["Irn"].markAsDirty;
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    selectDocuments(event: any) {
        const ALLOWED_TYPES = ["application/pdf"];

        this.files = Array.from(event);
        const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

        if (totalSize > Config.maxTotalSupportingDocsSize) {
            this.totalSizeError = true;
            this.sizeError = false;
            this.typeError = false;
            this.modalService.open(this.sizeErrorModal, this.modalOptions);
        }

        for (const file of this.files) {
            if (file.size > Config.maxFileSize) {
                this.sizeError = true;
                this.typeError = false;
                this.totalSizeError = false;
                continue;
            }

            // Filter out any files that are not Word, Excel, or PDF
            if (!ALLOWED_TYPES.includes(file.type)) {
                this.typeError = true;
                this.sizeError = false;
                this.totalSizeError = false;
                continue;
            }
            this.supportingDocuments.push(file);
        }

        if (this.allDeleted === true) {
            if (
                this.digitalLogisticsInvoice.get("terms_agreed").value === true
            ) {
                this.digitalLogisticsInvoice.patchValue({
                    terms_agreed: false,
                });
            }
        } else {
            this.digitalLogisticsInvoice.patchValue({ terms_agreed: false });
        }

        this.supportingDocsAdded = true;
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);
        this.recomputeFileErrors();

        if (this.supportingDocuments.length === 0) {
            if (
                this.digitalLogisticsInvoice.get("terms_agreed").value === true
            ) {
                this.digitalLogisticsInvoice.patchValue({
                    terms_agreed: false,
                });
            }

            this.canSubmitForm = false;
            this.allDeleted = true;
            this.supportingDocsAdded = false;
        }
    }

    private recomputeFileErrors() {
        const totalSize = this.supportingDocuments.reduce((sum, f) => sum + (f.size || 0), 0);
        if (totalSize <= Config.maxTotalSupportingDocsSize) this.totalSizeError = false;
        this.sizeError = false;
        this.typeError = false;
    }

    checkSupportingDocuments() {
        if (
            this.supportingDocuments.length > 0 &&
            this.digitalLogisticsInvoice.get("terms_agreed").value === false &&
            !this.invalidDate
        ) {
            this.canSubmitForm = true;
        } else {
            this.canSubmitForm = false;
        }
    }

    canDeactivate() {
        if (!this.formSubmitted) {
            this.loading = true;
            return false;
        } else {
            return true;
        }
    }

    exitForm() {
        this.loading = false;
        this.formSubmitted = true;
        this.router.navigateByUrl(this.previousUrl);
    }

    cancelExit() {
        this.loading = false;
    }

    onDrop(event: any) {
        // Update the list order
        moveItemInArray(
            this.supportingDocuments,
            event.previousIndex,
            event.currentIndex
        );
        this.supportingDocsAdded = true;
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > Config.maxFileSize) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
                this.modalService.open(this.sizeErrorModal, this.modalOptions);
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.digitalLogisticsInvoice.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;
                this.loading = true;
                this.formSubmitted = true;
                this.invoiceChanged = true;

                const formData: any = new FormData();
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("eippSession")
                );
                formData.append(
                    "file",
                    this.digitalLogisticsInvoice.value.fileSource
                );

                this.dsLoaderMsg = "Verifying Signature";

                setTimeout(() => {
                    this.dsLoaderMsg = "Authenticating Signature";
                }, 5000);
                setTimeout(() => {
                    this.dsLoaderMsg = "Extracting Data";
                }, 10000);
                setTimeout(() => {
                    this.dsLoaderMsg = "Validating Data";
                }, 15000);

                this.invoiceService.verifyDigitalSignature(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.formSubmitted = false;
                        this.invoiceChanged = false;
                        this.responseData = res;
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            this.hasError = true;
                        } else {
                            this.formData = this.responseData.data;
                            if (typeof this.formData.irn !== "undefined") {
                                this.irnExist = true;
                            } else {
                                this.irnExist = false;
                            }

                            let dDate;
                            if (
                                typeof this.formData.invoiceDate !== "undefined"
                            ) {
                                // Validate the invoiceDate format and year length
                                const docDtFormControl = this
                                    .digitalLogisticsInvoice.controls[
                                    "DocDt"
                                ] as FormControl;
                                docDtFormControl.valueChanges.subscribe(
                                    (newDate) => {
                                        this.checkAndUpdateDateValidity(
                                            newDate
                                        );
                                    }
                                );
                                dDate = this.formData.invoiceDate.replaceAll(
                                    ".",
                                    "/"
                                );
                            } else {
                                dDate = "";
                            }
                            this.digitalLogisticsInvoice.patchValue({
                                SellerGstin: this.formData.vendorGSTIN,
                                DocNo: this.formData.invoiceNumber,
                                DocDt: this.formData.invoiceDate.replaceAll(
                                    ".",
                                    "/"
                                ),
                                TotInvVal: this.formData.invoiceAmount,
                                Irn: this.formData.irn,
                            });
                            this.fileLink = this.responseData.file_link;
                            this.hasError = false;

                            this.fileLink = this.responseData.file_link;
                            this.hasError = false;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    onSubmitDigitalInvoice() {
        this.loading = true;

        this.uploadInvoice = true;
        this.formSubmitted = true;
        this.hasError = false;

        let irnValue = "";
        if (
            typeof this.formData.irn !== "undefined" ||
            typeof this.digitalLogisticsInvoice.value.Irn !== "undefined"
        ) {
            irnValue = this.digitalLogisticsInvoice.value.Irn;
        }

        const trimNo = (this.digitalLogisticsInvoice.value.DocNo || "").replace(
            /\s+/g,
            ""
        );

        // Get current user session data
        const currentUser = this.authService.getCurrentUser();
        const session = currentUser.eippSessionData.data.session;

        // Format date - convert DD/MM/YYYY to DDMMYYYY
        const docDate = this.dateUtils.formatDateString(
            this.digitalLogisticsInvoice.value.DocDt
        );

        // Create ledger structure matching curl format
        const timestamp = Date.now();
        const ledger = [
            {
                docDate: docDate,
                dueDate: docDate,
                dueAmt: parseFloat(
                    this.digitalLogisticsInvoice.value.TotInvVal.replaceAll(
                        ",",
                        ""
                    )
                ),
                docAmt: parseFloat(
                    this.digitalLogisticsInvoice.value.TotInvVal.replaceAll(
                        ",",
                        ""
                    )
                ),
                docType: "APINV",
                poNo: this.digitalLogisticsInvoice.value.poNo || "",
                docNo: trimNo,
                //timestamp: timestamp,
                currCode: "INR",
                status: "PENDING_SUBMISSION",
                supplierNm: localStorage.getItem("displayName"),
                docDetail: {
                    docAmt: this.digitalLogisticsInvoice.value.TotInvVal.replaceAll(
                        ",",
                        ""
                    ),
                    docFormat: this.invoiceService.getInvType() || "ds-invoice",
                    docCat: "logistics",
                    docGstin: this.digitalLogisticsInvoice.value.SellerGstin,
                    irn: irnValue,
                },
                docRef: [
                    {
                        src: this.formData.src || "",
                    },
                ],
                lineItemDetail: JSON.parse(localStorage.getItem("pods") || "[]").map((pod: any) => ({
                    poLineNo: pod.poLineNo,
                    grn: pod._id,
                    grnNo: pod.docNo,
                })),
                supplierCode: localStorage.getItem("vendorCode"),
                cmpCode: this.digitalLogisticsInvoice.value.companyCode,
                purchaseOrg: this.digitalLogisticsInvoice.value.purchaseOrg,
                erpDocType: this.digitalLogisticsInvoice.value.docType,
                email: this.formData.email_address || this.digitalLogisticsInvoice.value.emailAddress,
            },
        ];

        const formData: any = new FormData();
        formData.append("sellerCode", this.authService.getSellerCode());
        formData.append("reqType", "payexap");
        formData.append("session", JSON.stringify(session));
        formData.append("action", "add");
        formData.append("ledger", JSON.stringify(ledger));

        if (this.supportingDocuments.length !== 0) {
            for (let i = 0; i < this.supportingDocuments.length; i++) {
                formData.append("supportingDocs", this.supportingDocuments[i]);
            }
        } else {
            formData.append("supportingDocs", this.supportingDocuments);
        }

        if (!this.saving) {
            this.invoiceService
                .uploadInvoiceWithoutExtration(formData)
                .subscribe(
                    (res) => {
                        this.responseData = res;

                        if (this.responseData.status === "error") {
                            this.loading = false;
                            this.uploadInvoice = false;
                            this.hasError = true;
                            this.formSubmitted = false;
                        } else {
                            this.barcodeNo = this.responseData.barcode;
                            this.uploadSuccessful = true;
                            this.uploadInvoice = false;
                        }
                    },
                    (error) => {
                        console.error(error);
                        this.error = error;
                        this.loading = false;
                        this.uploadInvoice = false;
                        this.uploadSuccessful = false;
                        this.invoiceSaved = false;
                        this.serverError = true;
                    }
                );
        }

        this.modalService.dismissAll();
    }

    fetchPurchaseOrg() {
        const configReq = {
            type: "purchaseOrganizations",
        };

        this.invoiceService.getConfig(configReq).subscribe(
            (res) => {
                this.configResOrg = res;
                if (
                    this.configResOrg.length !== 0 &&
                    this.configResOrg.status === "error"
                ) {
                    console.error(this.configResOrg + " Error");
                } else {
                    this.organisations = this.configResOrg.data;
                    // Patch purchaseOrg after organisations are loaded
                    if (this.formData && this.formData.purchaseOrg) {
                        this.digitalLogisticsInvoice.patchValue({
                            purchaseOrg: this.formData.purchaseOrg,
                        });
                    }
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

    fetchCompanyCode() {
        const configReq = {
            type: "companyCodes",
        };

        this.invoiceService.getConfig(configReq).subscribe(
            (res) => {
                this.configResCompanies = res;
                if (
                    this.configResCompanies.length !== 0 &&
                    this.configResCompanies.status === "error"
                ) {
                    console.error(this.configResCompanies + " Error");
                } else {
                    this.companies = this.configResCompanies.data;
                    // Patch companyCode after companies are loaded
                    if (this.formData && this.formData.cmpCode) {
                        this.digitalLogisticsInvoice.patchValue({
                            companyCode: parseInt(this.formData.cmpCode),
                        });
                    }
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.invoiceDetails = this.invoiceService.getProcessedInvoice();
        this.formSubmitted = false;

        this.fetchCompanyCode();
        this.fetchPurchaseOrg();

        this.fileLink = this.invoiceService.fileUrl;
        this.reqData = this.invoiceService.getNonPOFields();
        this.formData = this.invoiceService.getDataDigitalInvoice();

        if (typeof this.formData.irn !== "undefined") {
            this.irnExist = true;
        }

        let documentDate;
        if (typeof this.formData.invoiceDate !== "undefined") {
            // Validate the invoiceDate format and year length
            const docDtFormControl = this.digitalLogisticsInvoice.controls[
                "DocDt"
            ] as FormControl;
            docDtFormControl.valueChanges.subscribe((newDate) => {
                this.checkAndUpdateDateValidity(newDate);
            });
            documentDate = this.formData.invoice_date.replaceAll(".", "/");
        } else {
            documentDate = "";
        }


        // Patch values that don't depend on async data
        this.digitalLogisticsInvoice.patchValue({
            SellerGstin: this.formData.gstin,
            DocNo: this.formData.invoice_number,
            DocDt: documentDate,
            TotInvVal: this.formData.invoice_amount,
            Irn: this.formData.irn,
            docType: this.formData.erpDocType,
            emailAddress: this.formData.email_address?.toLowerCase(),
            username: this.invoiceService.getUsername(),
            userID: this.invoiceService.getUserId(),
            poNo: this.formData.poNo,
        });

        this.loadFile();
        this.setAsDirty();
    }

    ngAfterViewInit(): void {
        // Subscribe to changes of the DocDt FormControl after initialization
        const docDtFormControl = this.digitalLogisticsInvoice.get(
            "DocDt"
        ) as FormControl;

        docDtFormControl.valueChanges.subscribe((newDate) => {
            this.checkAndUpdateDateValidity(newDate);
        });
    }

    checkAndUpdateDateValidity(newDate) {
        if (!this.isDateValid(newDate)) {
            this.invalidDate = true;
            this.dateError = true;
        } else {
            if (
                this.digitalLogisticsInvoice.get("terms_agreed").value === true
            ) {
                this.digitalLogisticsInvoice.patchValue({
                    terms_agreed: false,
                });
            }
            this.invalidDate = false;
            this.dateError = false;
        }
    }

    isDateValid(dateString: string): boolean {
        const dateParts = dateString.split(/[./]/); // Split using either "." or "/"

        if (dateParts.length !== 3) {
            return false;
        }

        const day = Number(dateParts[0]);
        const month = Number(dateParts[1]);
        const year = Number(dateParts[2]);

        const currentYear = new Date().getFullYear();

        // Check if day is within the range of 1 to 31 and not NaN
        if (isNaN(day) || day < 1 || day > 31) {
            return false;
        }

        // Check if month is within the range of 1 to 12 and not NaN
        if (isNaN(month) || month < 1 || month > 12) {
            return false;
        }

        // Check if year is within the range of 2000 to current year and not NaN
        if (isNaN(year) || year < 2000 || year > currentYear) {
            return false;
        }

        return true;
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    resubmitInvoice() {
        const poNo = this.route.snapshot.params["poNo"];
        this.router.navigate(["/submit-invoice", poNo]);
    }

    loadFile() {
        if (typeof FileReader !== "undefined") {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.pdfSrc = e.target.result;
            };
            let $file: any = this.invoiceService.getFileElement();
            reader.readAsArrayBuffer($file);
        }
    }

    onCheckboxChange(e: any) {
        if (e.target.checked) {
            this.digitalLogisticsInvoice.patchValue({
                terms_agreed: e.target.value,
            });
        } else {
            this.digitalLogisticsInvoice.patchValue({
                terms_agreed: null,
            });
        }
    }
}
